import i18n from 'utils/i18n';
const { t } = i18n;
export const expressionDefaultTextMap: { [key: string]: string } = {
  happy: t('很高兴认识你'),
  sad: t('你怎么能抛弃我'),
  angry: t('哼，不要理你了'),
};
